import { Component } from '@angular/core';

@Component({
    selector: 'app-project-dashboard',
    templateUrl: './project-dashboard.component.html',
    styleUrls: ['./project-dashboard.component.less'],
    standalone: false
})
export class ProjectDashboardComponent {

}
